module.exports = __webpack_public_path__ + "img/pentagon.be5030ca.webp";